module.exports = __webpack_public_path__ + "img/initialEle.d8668b7f.svg";